import React ,{useEffect} from 'react';
import AOS from 'aos';
import FirstPart from '../Components/Pages/BlogDetails/FirstPart';
import Header from '../Components/Shared/Header/Header';
import Sections1 from '../Components/Pages/BlogDetails/Sections1';
import LeftImage from '../Components/Pages/BlogDetails/LeftImage';
import Section from '../Components/Pages/BlogDetails/Section';
import Subscribe from '../Components/Pages/BlogDetails/Subscribe';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
const BlogDetails=()=>{
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header styles="scrolled"/>
        <FirstPart />
        <Sections1 />
        <LeftImage />
        <Section 
        title="Best productivity apps in 2020"
        desc="We’re listing the best productivity apps you can find this year. Following up on this list is a matter of clicking through our options and scouting our recommendations for productivity apps until one rings true for you. Let these help your business and personal processes! Once you know your precise needs, it’ll be much easier to pick the right productivity app to suit your personal needs and help your teams. Then, selecting the best productivity app is a matter of going through a wide range of software offers and picking the one that suits your personal and team needs the most. To achieve that in no time, we’ll now give you all you should know about the best productivity apps in 2020, as promised. "
        />
       

        <Subscribe />
        <Section 
        desc="According to Brian, this org structure provides the easiest route to a clear company mission that all can align to. For example, as the pandemic reshaped travel over the last nine months, this organizational technique allowed Airbnb to remain flexible and attuned to its customer needs. It helped them understand that one of the first things the organization needed to do when COVID-19 began sweeping the globe was focus on designing for safety and trust. This led them to hire a former U.S. Surgeon General to help guide new cleaning protocols for hosts on the rental platform, This organizational structure also helped the company pinpoint that there was a newly emerging segment of travelers who, able to work from anywhere, are looking to live somewhere new for a month or two. This allowed Airbnb to quickly pivot towards designing for people who aren’t just visitors, but also short-term residents. They also increased support for people seeking out smaller cities and lesser-known destinations as opposed to known tourist districts. "
        />
        <Start />
        <Footer />
        </>
    )
};
export default BlogDetails;